var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('a',{ref:"postLink",staticClass:"dc-button dc-button--has-icon dc-button--color-orange",attrs:{"href":_vm.url,"aria-label":_vm.aria_label}},[_c('span',{staticClass:"icon icon-arrow-right"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }